import { AxiosResponse } from "axios";
import { Ttrack, trackSurface } from "../shared/types/tracks.type";
import axiosInstance from "./base";
import { TFinishLine } from "../shared/types/finishLine.type";
import { TTrainingType } from "../shared/types/training.type";
import { TPublicTrack } from "../shared/types/publicTrack.type";
import { TrainingCenter } from "../shared/types/trainingCenter.type";
import { createCenterDto } from "../dto/createCenterDto";

export class TrackName {
  static getTracks(
    trainer?: number,
    allAvailable = false,
  ): Promise<AxiosResponse<Array<Ttrack>>> {
    return axiosInstance.get(
      `track_names?trainer=${trainer}&all-available=${allAvailable}&itemsPerPage=1000`,
    );
  }

  static getSuraces(): Promise<AxiosResponse<Array<trackSurface>>> {
    return axiosInstance.get(`track_surfaces?itemsPerPage=1000`);
  }
  static getTrack(id: number): Promise<AxiosResponse<Ttrack>> {
    return axiosInstance.get(`track_names/${id}`);
  }
  static getTrainingTypes(
    trainer: string,
    allAvailable?: boolean,
  ): Promise<AxiosResponse<TTrainingType[]>> {
    return axiosInstance.get(
      `training_types?trainer=${trainer}&itemsPerPage=1000`.concat(
        allAvailable ? `&all-available=${allAvailable}` : "",
      ),
    );
  }

  static saveFinishLine(
    data: Partial<TFinishLine>,
  ): Promise<AxiosResponse<TFinishLine>> {
    return axiosInstance.post("finish_lines", data);
  }

  static save(data: Partial<Ttrack>): Promise<AxiosResponse<Ttrack>> {
    return axiosInstance.post("track_names", data);
  }

  static update(
    data: { id: number; finish_line: string } | Partial<Ttrack>,
  ): Promise<AxiosResponse<Ttrack>> {
    return axiosInstance.patch(`track_names/${data.id}`, data, {
      headers: {
        "Content-Type": "application/merge-patch+json",
      },
    });
  }

  static delete(id: number) {
    return axiosInstance.delete(`track_names/${id}`);
  }
  static deleteFL(id: number) {
    return axiosInstance.delete(`finish_lines/${id}`);
  }

  static getPublicTracks(): Promise<AxiosResponse<TPublicTrack[]>> {
    return axiosInstance.get("public_tracks?itemsPerPage=1000");
  }

  static savePublicTracks(id: number, data: { public_tracks: string[] }) {
    return axiosInstance.post(`users/${id}/add-public-tracks`, data);
  }

  static getTrainingCenters(
    userId?: string,
  ): Promise<AxiosResponse<Array<TrainingCenter>>> {
    return axiosInstance.get(
      `training_centers`.concat(userId ? `?trainer=${userId}` : ""),
    );
  }

  static deleteTrainingCenter(id: number) {
    return axiosInstance.delete(`training_centers/${id}`);
  }

  static createTrainingCenter(data: createCenterDto) {
    return axiosInstance.post(`training_centers`, data);
  }
}
